import { render } from "./CreateBill.vue?vue&type=template&id=304bbbc1"
import script from "./CreateBill.vue?vue&type=script&lang=js"
export * from "./CreateBill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__